import {
  AssetState,
  AssetType,
  CountAssetsRequest
} from '@dtx-company/connect-codegen/src/gen/asset/v1/asset_pb'
import { PartialMessage } from '@bufbuild/protobuf'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useGetOrgId } from '@app/forms/src/hooks/useGetOrgId'
import { useTotalAssetCounts } from '@app/code/src/components/UnifiedAssetManagement/AllAssetsPageContainer/hooks/useTotalAssetCounts'

export const usePageLimit = (): { pageLimit: number; isAtPageLimit: boolean } => {
  const { pageLimit } = useAuthState()
  const orgId = useGetOrgId()

  const countAssetsArgs: PartialMessage<CountAssetsRequest> = {
    id: {
      case: 'orgId',
      value: orgId
    },
    filter: {
      assetTypes: [AssetType.PAGE],
      states: [AssetState.ACTIVE]
    }
  }

  const { totalAssetCount: pageCount } = useTotalAssetCounts(countAssetsArgs)

  const isPageLimitZero = pageLimit === 0
  const isAtPageLimit = pageCount && pageLimit > 0 ? pageCount >= pageLimit : false

  return {
    pageLimit,
    isAtPageLimit: isPageLimitZero || isAtPageLimit
  }
}
